import React, { useEffect, useRef } from "react";

const SquarePayment: React.FC = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const initializedRef = useRef(false); 

  useEffect(() => {
    if (initializedRef.current) return; 
    initializedRef.current = true;

    const script = document.createElement("script");
    script.src = "https://sandbox.web.squarecdn.com/v1/square.js";
    script.async = true;

    script.onload = async () => {
      try {
        const payments = (window as any).Square.payments(
          process.env.REACT_APP_SQUARE_APPLICATION_ID!,
          process.env.REACT_APP_SQUARE_LOCATION_ID!
        );

        const card = await payments.card();
        await card.attach(containerRef.current);

        const paymentButton = document.getElementById("square-pay-btn");
        paymentButton?.addEventListener("click", async () => {
          const result = await card.tokenize();
          if (result.status === "OK") {
            console.log("Token:", result.token);
            // Send this token to your backend for payment
          } 
        });
      } catch (err) {
        console.error("Square init failed:", err);
      }
    };

    document.body.appendChild(script);
  }, []);

  return (
    <div style={{ width: "400px", margin: "auto", paddingTop: "40px" }}>
      <div ref={containerRef} id="card-container"></div>
      <button
        id="square-pay-btn"
        style={{
          marginTop: "20px",
          width: "100%",
          height: "48px",
          background: "#C32340",
          borderRadius: "5px",
          color: "white",
          fontWeight: 500,
          fontSize: "16px",
        }}
      >
        Pay with Square
      </button>
    </div>
  );
};

export default SquarePayment;
